<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{$t('main.messageModalTitle')}}
    </div>
    <div class="msg-wrapper">
      <div class="name">
        {{modalData.usr_name}}
      </div>
      <textarea :placeholder="$t('main.yourMessage') + '...'" @keyup.enter="sendMsg()" v-model="msg" rows="5"></textarea>
      <div @click="sendMsg()" class="send-btn">
        <img src="@/assets/icons/btn-arrow.png" alt="enter-btn-arrow">
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { mapState } from 'vuex'
export default {
  name: 'messageModal',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      msg: null
    }
  },
  methods: {
    sendMsg () {
      if (this.msg) {
        let params = {
          msg_message: this.msg,
          usr_id_to: this.modalData.usr_id
        }
        this.connection.send(JSON.stringify(params))
        this.$toast.success(this.$t('main.msgSuccess'), {
          duration: 8000
        })
        this.msg = null
      } else {
        this.$toast.error(this.$t('main.msgError'), {
          duration: 8000
        })
      }
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  },
  computed: {
    ...mapState(['connection'])
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .msg-wrapper {
    width: 100%;
    margin-bottom: 20px;

    .name {
      text-align: left;
      margin-bottom: 25px;
      text-transform: capitalize;
      font-size: 15px;
      color: #9F9F9F;
    }

    textarea {
      width: calc(100% - 28px);
      resize: none;
      outline: none;
      border: 1px solid #F0F0F0;
      padding: 9px 13px;
      margin-bottom: 9px;
    }
    .send-btn {
      cursor: pointer;
      width: 32px;
      height: 32px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      border: 2px solid #7E394A;
      border-radius: 3px;
      margin-left: auto;

      img {
        height: 10px;
        width: 10px;
      }
    }
  }

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
